import { render, staticRenderFns } from "./insure-info-form.vue?vue&type=template&id=5bbb0002&"
import script from "./insure-info-form.vue?vue&type=script&lang=js&"
export * from "./insure-info-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports